module.exports = __webpack_public_path__ + "img/credentialing.f0702f2a.svg";